<template>
  <div class="company-holder">
    <div class="container">

      <div class="row history-holder">
        <div class="col-lg-7 text-center text-lg-start col-md-12">
          <div id="history-heading-holder">
            <p id="history-header">SOBRE NÓS</p>
            <p id="history-prologue">O início de um sonho motivado pela paixão a tecnologia</p>
          </div>
          <div id="history-body">
            <p id="history">Foi em 1990 motivado pela paixão em tecnologia e acompanhando 
              as tendencias comerciais que Jackson Luis Muller iniciou suas atividades no 
              setor de desenvolvimento de sistemas.
            </p>
          </div>

          <div class="w-100">
            <button type="button"
                    class="btn"
                    id="history-btn-first" 
                    data-bs-toggle="modal"
                    data-bs-target="#modalCompany">Leia mais</button>
          </div>

          <div class="icon-holder">
            <span class="contact-icon">
              <a target="_blank" href="https://www.youtube.com/watch?v=5rgFTMlQQDI&ab_channel=BytecomGroup"><i class="bi bi-youtube"></i></a>
            </span>
            <span class="contact-icon">
              <a target="_blank" href="https://www.instagram.com/bytecomsistemas/"><i class="bi bi-instagram"></i></a>
            </span>
            <span class="contact-icon">
              <a target="_blank" href="https://www.facebook.com/BytecomSistemas"><i class="bi bi-facebook"></i></a>
            </span>
          </div>
        </div>

        <div class="col-lg-5 position-relative d-none d-lg-block d-xl-block mb-4">
          <div id="img-holder" class="position-absolute"></div>
          <div id="background-element" class="position-absolute"></div>
        </div>

      </div>
    </div>

    <div class="modal modal-xl fade" id="modalCompany" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">Nossa história</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body text-center mt-2">
            <span>"Nossa missão é oferecer aos nossos clientes tranquilidade para que através de nossas ferramentas 
              possa ter informações necessárias a tomada de decisão e apoio a uma  gestão mais eficaz das empresas."
            </span>
          </div>
          <div class="modal-body text-start">
            <h6 style="font-weight: bold;" class="text-center">A Bytecom</h6>
            <p>Foi em 1990 motivado pela paixão em tecnologia e acompanhando as tendencias comerciais que Jackson Luis Muller iniciou suas atividades no setor de desenvolvimento de sistemas.</p>
            <p>“Antes de ingressar em desenvolvimento de sistemas no ano de 1989 fui proprietário da segunda escola de informática de Jaraguá do Sul e ainda como professor iniciei meus trabalhos em desenvolvimento de sistemas e prestação de serviços de forma informal e contando apenas com um computador MSX 1.0 da Gradiente e uma impressora matricial Olivia onde fazia a impressão dos boletos de pagamento das mensalidade da ACIJS (Associação Comercial e Industrial de Jaraguá do Sul)”. Conta um dos sócios fundadores da BYTECOM SISTEMAS E SERVIÇOS LTDA.</p>
            <p>“Foi então em 2002 que o Sr. Jackson conhece Weber Graziane Bernardes Luvisa e que através de uma grande afinidade decidem iniciar as atividades de forma formal sendo então idealizada a BYTECOM SISTEMAS E SERVIÇOS LTDA”. Contam os Sócios fundadores.</p>
            <p>Nossos produtos são desenvolvidos acompanhando sempre as melhores práticas de gestão de negócios e construídos com o uso das mais modernas tecnologias de mercado em desenvolvimento de sistemas, com alto desempenho e facilidade de uso, atendendo empresas de pequeno, médio e grande porte em todo o SUL do Brasil.</p>
            <p>O conhecimento e experiência acumulada nestes anos de atuação nos credenciam a oferecer soluções completas e inovadoras para empresas dos mais diversos segmentos de mercado como: comércios, mercados, serviços, restaurantes e indústrias.</p>
            <h6 style="font-weight: bold;" class="text-center">O que faz os sistemas da BYTECOM uma escolha inteligente para sua empresa?</h6>
            <p>O nosso diferencial e a forma de atendimento ao nosso cliente, fazendo do cliente um parceiro e não simplesmente um número entre os diversos sistemas vendidos. Nossa empresa atua no mercado a vários anos e têm centenas de clientes satisfeitos com os nossos sistemas e serviços. Além da implantação rápida, treinamos cada setor da empresa conforme a sua necessidade de uso. Possuímos um atendimento pós venda que mesmo não tendo nenhum problema fazemos a manutenção preventiva e analisamos o adequado andamento e uso do sistema.</p>
            <p>Disponibilizamos também serviços de consultoria junto à contabilidade fazendo desta forma um triângulo no aprimoramento dos recursos usando toda a funcionalidade do sistema.</p>
            <p>Dispomos de diversos módulos do sistema ao qual a empresa pode ir adquirindo conforme suas necessidades operacionais ou de gestão.</p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>

export default {
  name: 'SectionCompnay',
  components: {
  }
}
</script>

<style scoped>

#img-holder {
  margin-top: 10px;
  height: 500px;
  width: 400px;
  z-index: 2;

  border-radius: 10px;
  background-image: url("../assets/images/social-01.png"); 
}

#background-element {
  width: 400px;
  height: 500px;
  top: -10px;
  left: 30px;

  background: linear-gradient(90deg, rgba(92,107,167,0.6054796918767507) 0%, rgba(251,113,73,0.5970763305322129) 100%);
  opacity: 0.8;

  border-radius: 10px;
  z-index: 1;
}

.company-holder {
  padding: 70px 0 150px 0;
}

#history-heading-holder {
  width: 60%;
}

.history-holder {
  font-family: Montserrat Bold;
  margin: 0 7%;
}

.modal {
  font-family: Montserrat Regular;
}

#history-header {
  font-size: 2.5rem;
  color: #fb7149;
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
  margin-bottom: 10px;
}

#history-body {
  margin-top: 5%;
  width: 80%;
}

#history-prologue {
  font-size: 2.3rem;
  color: #242424;
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
  line-height: 95%;
}

#history-btn-first {
  background-image: linear-gradient(to right, #4258b1 0%, #eb5429  51%, #4258b1  100%);
  margin: 5% 5px 5px 0;
  transition: 0.5s;
  padding: 10px 30px;
  font-size: 14px;
  background-size: 200% auto;
  color: #fff;
  box-shadow: 0 0 5px rgba(238, 238, 238, 0.336);
  border-radius: 20px;
  font-family: Montserrat Regular;
}

.contact-icon {
  cursor: pointer;
  font-size: 40px;
  padding: 10px;

  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bi-youtube {
  font-size: 30px;
}

.bi-instagram {
  font-size: 25px;
}

.bi-facebook {
  font-size: 25px;
}

#history {
  font-size: 1.2rem;
  color: rgb(161, 161, 161);
  font-family: Montserrat Regular;
  line-height: 95%;
}

@media (max-width: 992px) {
  #history-heading-holder {
    width: 100%;
  }

  #history-body {
    width: 100%;
  }
}

</style>